import React from 'react'
import {isString} from 'lodash'
import {Helmet} from 'react-helmet'

const withHelmet = (
  Component,
  helmetContent = (props) => {
  }
) => {
  return (props) => {
    let content = isString(helmetContent) ? helmetContent : helmetContent(props)
    if (isString(content)) {
      content = (
        <title>{`Service Mocks - ${content}`}</title>
      )
    }
    if (content) {
      return (
        <>
          <Helmet>
            {content}
          </Helmet>
          <Component {...props}/>
        </>
      )
    }
    return (<Component {...props}/>)
  }
}

export {withHelmet}

export default withHelmet